import { Section } from './section';

export const SummaryCard = ({ classList = '', children }) => (
	<Section
		classList={classList}
		isShadow={true}
		sx={{ backgroundColor: '#f3f5f5', border: 'none', boxShadow: 'none', borderRadius: '12px' }}
		children={children}
	/>
);
